<template>
  <el-drawer
    :title="title"
    :visible.sync="drawer"
    :with-header="true"
    size="85%"
    :before-close="handleOpenDrawer"
  >
    <el-container>
      <el-main>
        <el-row>
          <span>Mes: {{ getMes }}</span>
          <div>
            Vendedor: {{ vendorName }}
            <span style="float: right">
              <strong>Total : {{ this.cantidad }}</strong>
            </span>
          </div>
        </el-row>

        <RabbeyTable3
          ref="table"
          v-loading="loading"
          :columns="columns"
          :data="items"
          :height="600"
          show-summary
          :summary-method="getSummaries"
        />
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import { formatMonto, formatDate } from "@/utils";

export default {
  name: "ContractDetails",
  components: { RabbeyTable3 },
  data() {
    return {
      vendorName: "",
      month: 0,
      title: "Detalles de contratos cancelados",
      drawer: false,
      cantidad: 0,
      PersonName: "",
      loading: false,
      items: [],
      contracsCancells: [],
      columns: [
        {
          prop: "Contract",
          label: "CONTRATO",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "Product",
          label: "Producto",
          minWidth: 300
          //  fixed: true
        },
        {
          prop: "CustomerCode",
          label: "CODIGO",
          minWidth: 100
          //  fixed: true
        },
        {
          prop: "CustomerName",
          label: "CLIENTE",
          minWidth: 400
          //    fixed: true
        },
        {
          prop: "FinalDate",
          label: "FECHA CIERRE",
          minWidth: 200,
          // fixed: true,
          formatter: (row) => formatDate(row.FinalDate, "DD/MM/yyyy")
        },

        {
          prop: "Qty",
          label: "CANT/PRODUCTOS",
          minWidth: 200
          // fixed: true
        },
        {
          prop: "Amount",
          label: "MONTO",
          minWidth: 200,
          // fixed: true,
          formatter: (row) => formatMonto(row.Amount)
        }
      ]
    };
  },
  computed: {
    getMes: function () {
      var retorno;
      switch (this.month) {
        case 1:
          retorno = "Enero";
          break;
        case 2:
          retorno = "Febrero";
          break;
        case 3:
          retorno = "Marzo";
          break;
        case 4:
          retorno = "Abril";
          break;
        case 5:
          retorno = "Mayo";
          break;
        case 6:
          retorno = "Junio";
          break;
        case 7:
          retorno = "Julio";
          break;
        case 8:
          retorno = "Agosto";
          break;
        case 9:
          retorno = "Septiembre";
          break;
        case 10:
          retorno = "Octubre";
          break;
        case 11:
          retorno = "Noviembre";
          break;
        case 12:
          retorno = "Diciembre";
          break;
      }
      return retorno;
    }
  },
  methods: {
    formatMonto,
    formatDate,
    clearData() {
      this.contracsCancells = [];
      this.cantidad = 0;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    show(props, year) {
      const { mes, tbl } = props;
      const { PersonCode, PersonName } = props.row;

      let params = {
        companyId: this.currentCompany,
        year: year,
        month: mes,
        personCode: PersonCode
      };
      let title = "";
      let url = "";

      if (tbl === "table_new") {
        title = "nuevos";
        url = "/api/SalesApi/ConctratsNewByVendor";
      } else if (tbl === "table_cancel") {
        title = "cancelados";
        url = "/api/SalesApi/ConctratsCanceled";
        params.status = 1;
      } else if (tbl === "table_seller") {
        title = "proximo a vencer";
        url = "/api/SalesApi/ConctratsCanceled";
        params.status = 0;
      }

      this.vendorName = PersonName;
      this.title = `Detalles de contratos ${title}`;
      this.month = mes;
      this.drawer = true;
      this.loading = true;

      this.$http
        .get(url, { params: params })
        .then((resp) => {
          if (resp.data["Items"] !== undefined) {
            const { Items } = resp.data;
            this.items = Items;
            this.cantidad = Items.length;
          } else {
            this.items = resp.data;
            this.cantidad = resp.data.length;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleOpenDrawer(done) {
      this.clearData();
      done();
    }
  }
};
</script>

<style></style>
